import { render, staticRenderFns } from "./vipInfo.vue?vue&type=template&id=021d9a59&scoped=true&"
import script from "./vipInfo.vue?vue&type=script&lang=js&"
export * from "./vipInfo.vue?vue&type=script&lang=js&"
import style0 from "./vipInfo.vue?vue&type=style&index=0&id=021d9a59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021d9a59",
  null
  
)

export default component.exports